module.exports = __webpack_public_path__ + "assets/img/smartTV-module5-10.1d1e531c.jpg";